enum OnePageGivingFormField {
  Amount = 'GivingPageDonation.Amount',
  IsAmountCustom = 'GivingPageDonation.IsAmountCustom',
  HasButtonSelected = 'GivingPageDonation.HasButtonSelected',
  RecaptchaResponse = 'RecaptchaResponse',
  EmbeddedPaymentPaymentMethodData = 'EmbeddedPayment.PaymentMethodData',
  EmbeddedPaymentAdditionalData = 'EmbeddedPayment.AdditionalData',
  IsEmbeddedHostedPayment = 'IsEmbeddedHostedPayment',
};

export default OnePageGivingFormField;